import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import BlogPostTemplate from '../components/BlogPostTemplate'
import Layout from '../components/Layout'
import { HTMLContent } from '../components/Content'
import _ from 'lodash'

const BlogPost = ({ data, pageContext }) => {
  const { markdownRemark: post } = data

  return (
    <Layout>
      <BlogPostTemplate
        content={post.html}
        contentComponent={HTMLContent}
        date={post.frontmatter.date}
        description={post.frontmatter.description}
        featuredImage={post.frontmatter.featuredImage.image}
        featuredImageAlt={post.frontmatter.featuredImage.alt}
        featuredImageTitle={post.frontmatter.featuredImage.title}
        featuredImageCaption={post.frontmatter.featuredImage.caption}
        author={post.frontmatter.author}
        href={
          data.site.siteMetadata.siteUrl +
          _.replace(post.fields.slug, /[0-9-]+_/, '')
        }
        helmet={
          <Helmet titleTemplate={`%s | One and Only Paper`}>
            <title>{`${post.frontmatter.title}`}</title>
            <meta
              name="description"
              content={`${post.frontmatter.description}`}
            />
          </Helmet>
        }
        slug={post.fields.slug}
        tags={post.frontmatter.tags}
        title={post.frontmatter.title}
      />
    </Layout>
  )
}

BlogPost.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
}

export default BlogPost

export const pageQuery = graphql`
  query BlogPostByID($id: String!) {
    site {
      siteMetadata {
        siteUrl
      }
    }
    markdownRemark(id: { eq: $id }) {
      id
      html
      fields {
        slug
      }
      frontmatter {
        date
        title
        description
        author
        tags
        featuredImage {
          alt
          caption
          title
          image {
            childImageSharp {
              fluid(maxWidth: 540, quality: 100) {
                ...GatsbyImageSharpFluid
              }
            }
            publicURL
          }
        }
      }
    }
  }
`
